import { render } from "./LitigationEditor.vue?vue&type=template&id=2ac13e56&scoped=true"
import script from "./LitigationEditor.vue?vue&type=script&lang=js"
export * from "./LitigationEditor.vue?vue&type=script&lang=js"

import "./LitigationEditor.vue?vue&type=style&index=0&id=2ac13e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac13e56"]])

export default __exports__